import { useMemo } from 'react';

/**
 * Memoizes a StyleSheet factory. Colors are static now that the Crop Circle
 * redesign is fully rolled out (no runtime theme toggle), so this only needs
 * to avoid recreating styles on every render.
 */
export function useThemedStyles<T>(styleCreator: () => T): T {
  return useMemo(() => styleCreator(), [styleCreator]);
}
